export const getRooms = (rooms: number | null) => {
  if (rooms === null) return "";
  return `${rooms} rum`;
};

export function getRoomRange(min: number | null, max: number | null) {
  if (min && max) {
    if (min === max) return `${min} rum`;
    return `${min} - ${max} rum`
  }
  if (min) {
    return `Från ${min} rum`
  }
  if (max) {
    return `Upp till ${min} rum`
  }

  return "";
}
